module.exports = __webpack_public_path__ + "img/bg.db69a840.svg";